export default __webpack_public_path__ + "static/media/21.bbd1d67b.jpeg";